import { BlurEvent, DataSourceExecutionEvent, DropdownSelectionEvent, LookupModelSearchEvent, LookupModelSelectionEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutCarrierSalesExpand } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierSalesExpand";
import { ModelRow } from "@mcleod/core";
import { CarrierAction } from "./CarrierAction";
import { ModelCarrierObjection } from "@mcleod/crm";

export class CarrierSalesExpand extends AutogenLayoutCarrierSalesExpand {

    textboxStatusAfterDropdownSelection(event: DropdownSelectionEvent) {
        if ("P" === event.selection.value){
            this.activeRow.set("action_date", null);
        } else {
            this.activeRow.set("action_date", new Date());
        }
    }
    textboxObjectionId1OnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.textboxObjection1Script.text = event.hasSelection() ? event.getValueFromSelectedRow("response_script") : null;
    }

    textboxObjectionId2OnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.textboxObjection2Script.text = event.hasSelection() ? event.getValueFromSelectedRow("response_script") : null;
    }

    sourceCarrierActionAfterExecution(event: DataSourceExecutionEvent) {
        if (this.activeRow) {
            if (!this.activeRow.isNull("objection_id1")) {
                this.findAndSetObjectionValues("objection_id1", this.textboxObjection1Script);
            }
            if (!this.activeRow.isNull("objection_id2")) {
                this.findAndSetObjectionValues("objection_id2", this.textboxObjection2Script);
            }

            this.syncNextActivity();
        }
    }

    textboxDateDueOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            this.syncNextActivity();
        }
    }

    carrierTypeSearchFilter(event: LookupModelSearchEvent) {
        event.filter.type_of = "A";
    }

    textboxNextActIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.id = "!RECCALL";
        this.carrierTypeSearchFilter(event);
    }

    findAndSetObjectionValues(targetField: string, targetComponent: Textbox) {
        const objectionId = this.activeRow.getString(targetField);
        new ModelCarrierObjection().searchSingle({ id: objectionId, "type_of": "A" })
        .then((modelRow: ModelRow) => {
            this.activeRow.setLookupModelData(targetField, modelRow);
            targetComponent.text = modelRow.getString("response_script");
            this.mainDataSource.displayDataInBoundComponents();
        })
    }

    async textboxNextActionAfterDropdownSelection(event: DropdownSelectionEvent) {
        await this.syncNextActivity();
        if (event.hasSelection()) {
            this.textboxNextActId.required = true;
            this.textboxNextActDate.required = true;
            switch (event.selection.value) {
                case "A":
                    this.activeRow.setValues({
                        "next_act_id": null,
                        "next_act_date": null
                    });
                    this.textboxNextActId.clear();
                    this.textboxNextActDate.clear();
                    this.textboxNextActId.enabled = true;
                    this.textboxNextActDate.enabled = true;
                    break;
                case "U":
                    this.textboxNextActId.enabled = false;
                    this.textboxNextActDate.enabled = true;
                    break;
            }
        } else if (event.hasDeselection()) {
            this.textboxNextActId.enabled = this.textboxNextActId.required = false;
            this.textboxNextActDate.enabled = this.textboxNextActDate.required = false;
        }
    }

    syncNextActivity() {
        const actionId = this.activeRow.getString("id", null);
        const carrierId = this.activeRow.getString("carrier_id", null);
        const dateDue = this.activeRow.getDate("date_due", null);
        return CarrierAction.findNextActivity(actionId, carrierId, dateDue).then((nextActivity) => {
            if (nextActivity.id) {
                this.activeRow.setValueAndLookupModelData("next_act_id", nextActivity.id, { "id": nextActivity.id, "descr": nextActivity.descr });
                this.activeRow.set("next_act_date", nextActivity.date_due);
            } else {
                this.activeRow.setValues({
                    "next_act_id": null,
                    "next_act_date": null
                });
            }
            this.textboxNextActId.displayComponentData(this.activeRow, null, 0);
            this.textboxActionDate.displayComponentData(this.activeRow, null, 0);
        });
    }
}